import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExtensionLimitSettingsQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
  domainId: Types.Scalars['Int']['input'];
  numberId: Types.Scalars['Int']['input'];
  isSuperuser: Types.Scalars['Boolean']['input'];
}>;


export type ExtensionLimitSettingsQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', capabilitySets: Array<{ __typename?: 'DomainAllocationInfoWithName', domainUsed: number, domainAllocated: number, systemLimit?: number | null, totalAllocated?: number, name: string }>, deviceTypeSets: Array<{ __typename?: 'DomainAllocationInfoWithName', domainUsed: number, domainAllocated: number, systemLimit?: number | null, totalAllocated?: number, name: string }>, userPackages: Array<{ __typename?: 'DomainAllocationInfoWithName', name: string, domainUsed: number, domainAllocated: number, systemLimit?: number | null, totalAllocated?: number, allocationIncrementError?: { __typename?: 'Error', type: string, context?: string | null } | null }> }, userQuotaInfo?: { __typename?: 'UserQuotaInfo', capabilitySets: Array<string>, deviceTypeSets: Array<{ __typename?: 'UserDeviceTypeSetQuota', name: string, value?: number | null }> } | null, users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', userPackageName?: string | null, displayName: string } | null> } | null, userPackages: Array<{ __typename?: 'UserPackageInfo', type: string, name: string, quota: number, capabilitySets: Array<string>, deviceTypeSets: Array<{ __typename?: 'UserPackageDeviceTypeSet', name: string, quantity: number }> }>, groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', name: string, members: Array<{ __typename?: 'GroupMembership', numberId: number, controllingLine: boolean, number?: { __typename?: 'Number', extension?: { __typename?: 'User', id: number } | null } | null }> } | null> } | null, capabilitySets?: Array<{ __typename?: 'CapabilitySet', name: string, capabilities: Array<string> } | null> | null, deviceLimit: Array<{ __typename?: 'DeviceSetLimit', setName: string, devices: Array<string>, limit?: number | null }>, deviceTypeSets: Array<{ __typename?: 'DeviceTypeSet', name: string, devices: Array<string> }> };

export type UpdateExtensionLimitMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  userPackageName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  capabilitySets?: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
  deviceTypeSets?: Types.InputMaybe<Array<Types.UpdateDeviceTypeSetLimit>>;
}>;


export type UpdateExtensionLimitMutation = { __typename?: 'Mutation', updateUserLimit: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } };

export type ExtensionNumberIdQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type ExtensionNumberIdQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', numberId: number } | null> } | null };


export const ExtensionLimitSettingsDocument = gql`
    query ExtensionLimitSettings($userId: Int!, $domainId: Int!, $numberId: Int!, $isSuperuser: Boolean!) {
  domainAllocation(domainId: $domainId) {
    capabilitySets {
      domainUsed
      domainAllocated
      systemLimit @include(if: $isSuperuser)
      totalAllocated @include(if: $isSuperuser)
      name
    }
    deviceTypeSets {
      domainUsed
      domainAllocated
      systemLimit @include(if: $isSuperuser)
      totalAllocated @include(if: $isSuperuser)
      name
    }
    userPackages {
      name
      domainUsed
      domainAllocated
      systemLimit @include(if: $isSuperuser)
      totalAllocated @include(if: $isSuperuser)
      allocationIncrementError {
        type
        context
      }
    }
  }
  userQuotaInfo(userId: $userId) {
    capabilitySets
    deviceTypeSets {
      name
      value
    }
  }
  users(id: $userId) {
    items {
      userPackageName
      displayName
    }
  }
  userPackages {
    type
    name
    quota
    capabilitySets
    deviceTypeSets {
      name
      quantity
    }
  }
  groups(memberNumberId: $numberId, type: CALL_QUEUE) {
    items {
      name
      members {
        numberId
        number {
          extension {
            id
          }
        }
        controllingLine
      }
    }
  }
  capabilitySets {
    name
    capabilities
  }
  deviceLimit(userId: $userId) {
    setName
    devices
    limit
  }
  deviceTypeSets {
    name
    devices
  }
}
    `;

/**
 * __useExtensionLimitSettingsQuery__
 *
 * To run a query within a React component, call `useExtensionLimitSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtensionLimitSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtensionLimitSettingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      domainId: // value for 'domainId'
 *      numberId: // value for 'numberId'
 *      isSuperuser: // value for 'isSuperuser'
 *   },
 * });
 */
export function useExtensionLimitSettingsQuery(baseOptions: Apollo.QueryHookOptions<ExtensionLimitSettingsQuery, ExtensionLimitSettingsQueryVariables> & ({ variables: ExtensionLimitSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtensionLimitSettingsQuery, ExtensionLimitSettingsQueryVariables>(ExtensionLimitSettingsDocument, options);
      }
export function useExtensionLimitSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtensionLimitSettingsQuery, ExtensionLimitSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtensionLimitSettingsQuery, ExtensionLimitSettingsQueryVariables>(ExtensionLimitSettingsDocument, options);
        }
export function useExtensionLimitSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtensionLimitSettingsQuery, ExtensionLimitSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtensionLimitSettingsQuery, ExtensionLimitSettingsQueryVariables>(ExtensionLimitSettingsDocument, options);
        }
export type ExtensionLimitSettingsQueryHookResult = ReturnType<typeof useExtensionLimitSettingsQuery>;
export type ExtensionLimitSettingsLazyQueryHookResult = ReturnType<typeof useExtensionLimitSettingsLazyQuery>;
export type ExtensionLimitSettingsSuspenseQueryHookResult = ReturnType<typeof useExtensionLimitSettingsSuspenseQuery>;
export type ExtensionLimitSettingsQueryResult = Apollo.QueryResult<ExtensionLimitSettingsQuery, ExtensionLimitSettingsQueryVariables>;
export const UpdateExtensionLimitDocument = gql`
    mutation UpdateExtensionLimit($id: Int!, $userPackageName: String, $capabilitySets: [String!], $deviceTypeSets: [UpdateDeviceTypeSetLimit!]) {
  updateUserLimit(
    id: $id
    userPackageName: $userPackageName
    capabilitySets: $capabilitySets
    deviceTypeSets: $deviceTypeSets
  ) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type UpdateExtensionLimitMutationFn = Apollo.MutationFunction<UpdateExtensionLimitMutation, UpdateExtensionLimitMutationVariables>;

/**
 * __useUpdateExtensionLimitMutation__
 *
 * To run a mutation, you first call `useUpdateExtensionLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExtensionLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExtensionLimitMutation, { data, loading, error }] = useUpdateExtensionLimitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userPackageName: // value for 'userPackageName'
 *      capabilitySets: // value for 'capabilitySets'
 *      deviceTypeSets: // value for 'deviceTypeSets'
 *   },
 * });
 */
export function useUpdateExtensionLimitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExtensionLimitMutation, UpdateExtensionLimitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExtensionLimitMutation, UpdateExtensionLimitMutationVariables>(UpdateExtensionLimitDocument, options);
      }
export type UpdateExtensionLimitMutationHookResult = ReturnType<typeof useUpdateExtensionLimitMutation>;
export type UpdateExtensionLimitMutationResult = Apollo.MutationResult<UpdateExtensionLimitMutation>;
export type UpdateExtensionLimitMutationOptions = Apollo.BaseMutationOptions<UpdateExtensionLimitMutation, UpdateExtensionLimitMutationVariables>;
export const ExtensionNumberIdDocument = gql`
    query ExtensionNumberId($userId: Int!) {
  users(id: $userId) {
    items {
      numberId
    }
  }
}
    `;

/**
 * __useExtensionNumberIdQuery__
 *
 * To run a query within a React component, call `useExtensionNumberIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtensionNumberIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtensionNumberIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useExtensionNumberIdQuery(baseOptions: Apollo.QueryHookOptions<ExtensionNumberIdQuery, ExtensionNumberIdQueryVariables> & ({ variables: ExtensionNumberIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtensionNumberIdQuery, ExtensionNumberIdQueryVariables>(ExtensionNumberIdDocument, options);
      }
export function useExtensionNumberIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtensionNumberIdQuery, ExtensionNumberIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtensionNumberIdQuery, ExtensionNumberIdQueryVariables>(ExtensionNumberIdDocument, options);
        }
export function useExtensionNumberIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtensionNumberIdQuery, ExtensionNumberIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtensionNumberIdQuery, ExtensionNumberIdQueryVariables>(ExtensionNumberIdDocument, options);
        }
export type ExtensionNumberIdQueryHookResult = ReturnType<typeof useExtensionNumberIdQuery>;
export type ExtensionNumberIdLazyQueryHookResult = ReturnType<typeof useExtensionNumberIdLazyQuery>;
export type ExtensionNumberIdSuspenseQueryHookResult = ReturnType<typeof useExtensionNumberIdSuspenseQuery>;
export type ExtensionNumberIdQueryResult = Apollo.QueryResult<ExtensionNumberIdQuery, ExtensionNumberIdQueryVariables>;